/** TypingBubble (06 §4.7) — incoming-style bubble with three animated dots. */
import styles from './TypingBubble.module.css';

export function TypingBubble() {
  return (
    <div className={styles.wrap} aria-label="typing">
      <div className={styles.bubble}>
        <span className={styles.dot} />
        <span className={styles.dot} />
        <span className={styles.dot} />
      </div>
    </div>
  );
}
